import { jwtDecode } from 'jwt-decode';
import { store } from 'store';

let loggingOut = false;

const JWT_AUTH_ERRORS = [
    'token é inválido',
    'token expirado',
    'token não encontrado',
    'token invalid',
    'token expired',
    'unauthenticated'
];

export const isTokenValid = (token = localStorage.getItem('token')) => {
    if (!token) {
        return false;
    }

    try {
        const decoded = jwtDecode(token);
        if (!decoded?.exp) {
            return true;
        }
        return decoded.exp * 1000 > Date.now();
    } catch {
        return false;
    }
};

export const clearSession = ({ redirect = true } = {}) => {
    if (loggingOut) {
        return;
    }

    loggingOut = true;
    localStorage.removeItem('token');
    store.dispatch({ type: 'SET_LOGOUT' });

    if (redirect && !window.location.pathname.includes('/login')) {
        window.location.href = '/login';
    }

    setTimeout(() => {
        loggingOut = false;
    }, 1000);
};

const extractErrorMessage = (data) => {
    if (!data) {
        return '';
    }
    if (typeof data === 'string') {
        return data;
    }
    if (typeof data.error === 'string') {
        return data.error;
    }
    if (typeof data.message === 'string') {
        return data.message;
    }
    return '';
};

const isJwtAuthFailure = (error) => {
    if (error?.response?.status !== 401) {
        return false;
    }

    const message = extractErrorMessage(error.response.data).toLowerCase().trim();
    if (!message) {
        // Sem mensagem clara: não desloga (API usa 401 em erros de negócio)
        return false;
    }

    return JWT_AUTH_ERRORS.some((authError) => message.includes(authError));
};

export const handleUnauthorized = (error) => {
    const url = error?.config?.url || '';
    const isPublicAuth =
        url.includes('login') ||
        url.includes('password/email') ||
        url.includes('password/reset') ||
        url.includes('register');

    if (!isPublicAuth && isJwtAuthFailure(error)) {
        clearSession({ redirect: true });
    }

    return Promise.reject(error);
};
